// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1456 ? "225f8dbd" : chunkId) + "." + {"71":"d394d984b1049ebb","1456":"bac8290c75f96ee1","4512":"3bb2fc0540aa483d","8611":"eb44f88f49af37ae","8931":"61dcbadd48907207"}[chunkId] + ".js";
};